import { render, staticRenderFns } from "./lesson-takeaways.vue?vue&type=template&id=7c1f9374&scoped=true"
import script from "./lesson-takeaways.vue?vue&type=script&lang=js"
export * from "./lesson-takeaways.vue?vue&type=script&lang=js"
import style0 from "./lesson-takeaways.vue?vue&type=style&index=0&id=7c1f9374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1f9374",
  null
  
)

export default component.exports